<template>
  <CompaniesTable
    feature="search"
    :has-pagination="false"
    :scroll-top-on-page-change="false"
    :size="5"
    view="demo-step"
  />
</template>
